import { Customer } from 'data/firestore/agent/customer/types';
import { Message } from 'data/firestore/agent/thread/message/types';
import { ItemUser } from 'data/firestore/globals';

const getCreatedBy = ({
    agentId,
    message,
    customer,
}: {
    agentId?: string,
    message: Message,
    customer: Customer,
}): ItemUser => {
    const { createdBy: metadataCreatedBy } = (message.metadata || { }) as { createdBy: ItemUser };
    const { createdBy: messageCreatedBy } = message;

    const createdBy = metadataCreatedBy?.uid ? metadataCreatedBy : messageCreatedBy;

    if (createdBy?.role === 'customer' || message.role === 'user') {
        const { id, ...rest } = customer;
        return {
            ...rest,
            uid: id,
            role: 'customer',
        } as ItemUser;
    }

    if (createdBy?.role === 'user') {
        return createdBy;
    }

    return {
        uid: agentId,
        role: 'agent',
        displayName: 'Sara',
    } as ItemUser;
};

export default getCreatedBy;
